// We assume that the load order set by our HTML will ensure that the
// following are already loaded:
//     js_detection.js;
//     defer_until_loaded.js;
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '@hotwired/turbo-rails';

Turbo.session.drive = false;

import {Settings} from 'luxon';
Settings.defaultZone = 'Europe/London';

import 'jquery';
import 'mediaMatch';

import $Form from 'application/common/forms';
import { initAccordions } from 'application/common/accordions';
import { initAuthentication } from 'application/common/authentication';

import Rails from '@rails/ujs'
Rails.start();

import 'cocoon';
import 'fileUpload';
import 'fileUploadProcess';
import 'fileUploadValidation';
import 'application/common/upload-files';
import lazyLoadComponents from 'application/lazy_load_components';
lazyLoadComponents();

import * as ActiveStorage from '@rails/activestorage';
ActiveStorage.start();

// TODO: move what we can to NPM, rather than manually maintaining it here
// We should also make sure we're not pulling scripts into every page which don't need to be
// on every page
import 'jquery.history';
import 'jquery.smart-poll';
import 'jquery-placeholder';
import 'jquery.ba-throttle-debounce';

import 'application/common/bookings.coffee';
import 'application/common/car_form.coffee';
import 'application/common/careers.coffee';
import 'application/common/cm_power100.coffee';
import 'application/common/cookie_consent';
import 'application/common/custom_checkbox';
import 'application/common/date_time_picker';
import 'application/common/direct_uploads';
import 'application/common/dropdown.coffee';
import 'application/common/facebook-pixel';
import 'application/common/forms.coffee';
import 'application/common/global.coffee';
import 'application/common/google_maps';
import 'application/common/information_prompt.coffee';
import 'application/common/landing_pages.coffee';
import 'application/common/landing_pages_view_more';
import 'application/common/mechanics.coffee';
import 'application/common/modal.coffee';
import 'application/common/navbar.coffee';
import 'application/common/floating_cta_button.coffee';
import 'application/common/promo-code-form';
import 'application/common/recaptcha';
import 'application/common/resolution_cases.coffee';
import 'application/common/scroll-to-anchor.coffee';
import 'application/common/secondary-nav.coffee';
import 'application/common/site.coffee';
import 'application/common/tabbed-nav.coffee';
import 'application/common/testimonials';
import 'application/common/cross-sells';
import 'application/common/utils';
import 'application/common/zendesk_web_widget';

import initBookingPageHeader from 'application/common/booking_page_header';

// Include pages
// Defines the $.fn.bindMechanicWorkItemsList plugin, which the work items views call from an
// inline DOMContentLoaded script, so it has to be available synchronously rather than lazily.
import 'application/pages/mechanic-work-items';

// Every other page script is fetched on demand — see lazy_page_modules for the registry.
import lazyLoadPageModules from 'application/lazy_page_modules';

import 'controllers';

// Set-up
$(function () {
  initAccordions();
  initAuthentication();
  initBookingPageHeader();
  $Form.setUpWatch();
  lazyLoadPageModules();
});
